import { FILTER_TYPE } from './filterType';

const { PLATFORM, BROWSER, COUNTRY, SITE, OS_FAMILY, OS_VERSION } = FILTER_TYPE;

export const RESTRICTED_FILTER_TYPES = {
    [PLATFORM]: [SITE, COUNTRY, BROWSER, OS_FAMILY, OS_VERSION],
    [COUNTRY]: [SITE, PLATFORM],
    [SITE]: [COUNTRY, PLATFORM],
    [BROWSER]: [PLATFORM],
    [OS_FAMILY]: [PLATFORM],
    [OS_VERSION]: [PLATFORM],
};
